import { File } from '@/features/files/types/file.types';

export const mockFiles: File[] = [
  {
    id: '20250522232724_b5f2796d-5183-4f75-9e0d-98fSDfefze98',
    nom: 'remb_sante.jpg',
    risque: 3,
    anomalies: 1,
    logiciel: 'adobe_photoshop',
    comment: 'Document médical',
    historique: false,
    received_timestamp: '2025-04-14T18:29:22.008305',
    lu: true,
    favori: true,
    archive: false,
  },
  {
    id: '20250522232724_b5f2796d-5183-4f75-9e0d-98fSDfefze98',
    nom: 'facture_services_001.pdf',
    risque: 3,
    anomalies: 5,
    logiciel: 'adobe_acrobat',
    comment: '',
    historique: true,
    received_timestamp: '2025-04-14T18:39:46.522139',
    lu: true,
    favori: false,
    archive: false,
  },
  {
    id: '20250414182934_c0794b7a-9687-4407-a021-f42b67a24491',
    nom: 'piece_identite_001.pdf',
    risque: 1,
    anomalies: 0,
    logiciel: 'adobe_acrobat',
    comment: '',
    historique: false,
    received_timestamp: '2025-04-14T18:29:34.284075',
    lu: true,
    favori: true,
    archive: false,
  },
  {
    id: '20250414183918_cc3c4c85-e8d5-471c-9a72-8a4702905895',
    nom: 'document_securise_001.jpg',
    risque: 2,
    anomalies: 0,
    logiciel: 'adobe_photoshop',
    comment: 'Document sécurisé',
    historique: false,
    received_timestamp: '2025-04-14T18:39:18.879504',
    lu: true,
    favori: true,
    archive: false,
  },
  {
    id: '20250425083135_5af3f086-b7ef-4425-97fa-9177a95a54e4',
    nom: 'piece_identite_002.pdf',
    risque: 3,
    anomalies: 3,
    logiciel: 'ilovepdf',
    comment: '',
    historique: true,
    received_timestamp: '2025-04-25T08:31:35.666059',
    lu: true,
    favori: true,
    archive: false,
  },
  {
    id: '20250423073838_73eb8190-c66d-4ee0-a109-1e0660b3de25',
    nom: 'document_securise_002.jpg',
    lu: true,
    favori: false,
    archive: false,
    risque: 0,
    anomalies: 0,
    logiciel: null,
    historique: false,
    received_timestamp: '2025-04-23T07:38:38.613939',
    comment: '',
  },
  {
    id: '20250414183945_3e3b8396-9fd2-401b-b29e-d0649151fbfa',
    nom: 'devis_services_001.pdf',
    lu: true,
    favori: false,
    archive: false,
    risque: 0,
    anomalies: 0,
    logiciel: null,
    historique: false,
    received_timestamp: '2025-04-14T18:39:46.239815',
    comment: '',
  },
  {
    id: '20250425082820_8aa881ff-5095-4db8-9af9-eb4e4ba4d574',
    nom: 'document_analyse_001.jpg',
    lu: true,
    favori: false,
    archive: false,
    risque: 3,
    anomalies: 2,
    logiciel: null,
    historique: true,
    received_timestamp: '2025-04-25T08:28:20.556512',
    comment: 'Document validé',
  },
  {
    id: '20250425082935_2be3656b-d664-41ab-810c-c538b0c27a16',
    nom: 'document_analyse_002.jpg',
    lu: true,
    favori: false,
    archive: false,
    risque: 2,
    anomalies: 1,
    logiciel: null,
    historique: true,
    received_timestamp: '2025-04-25T08:29:35.746414',
    comment: '',
  },
  {
    id: '20250425083441_17b96520-cf84-4d92-ada6-f2881dc188e8',
    nom: 'document_analyse_003.jpg',
    lu: true,
    favori: true,
    archive: false,
    risque: 3,
    anomalies: 2,
    logiciel: null,
    historique: false,
    received_timestamp: '2025-04-25T08:34:42.207306',
    comment: 'À relire',
  },
];
